var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5V0H0V5V6V8V9V11V12V14V15V17V18V20V21V23V24H1H23H24V23V21V20V18V17V15V14V12V11V9V8V6V5ZM23 8V6H18V8H23ZM17 8V6H12V8H17ZM11 8V6H6V8H11ZM5 8V6H1V8H5ZM18 18H23V20H18V18ZM12 18H17V20H12V18ZM6 18H11V20H6V18ZM1 18H5V20H1V18ZM5 23H1V21H5V23ZM6 21V23H11V21H6ZM17 21V23H12V21H17ZM18 21V23H23V21H18ZM18 15H23V17H18V15ZM12 15H17V17H12V15ZM6 15H11V17H6V15ZM1 15H5V17H1V15ZM18 12H23V14H18V12ZM12 12H17V14H12V12ZM6 12H11V14H6V12ZM1 12H5V14H1V12ZM18 9H23V11H18V9ZM12 9H17V11H12V9ZM6 9H11V11H6V9ZM1 9H5V11H1V9Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.549d0bbc7eba8d72f751311f8e6cf6bc.svg";
export { ForwardRef as ReactComponent };